import { departmentAndEmployeeConstantsExport } from "../constant/totalRecord.constants";

export const initialState = {
    listDepartmentSelectBoxEx: {
        departmentId: '',
        departmentName: ''
    },
    listEmployeeSelectBoxEx: {
        employeeId: '',
        employeeCode: '',
        employeeName: '',
    },
    isLoading: false,
    errorCode: '',
    successCode: '',
};

const departmentAndEmployeeReducerExport = (state = initialState, action) => {
    switch (action.type) {
        case departmentAndEmployeeConstantsExport.GET_SUCCESS:
            return {
                ...state,
                listDepartmentSelectBoxEx: action.departmentListAndEmployee.listDepartmentSelectBox,
                listEmployeeSelectBoxEx: action.departmentListAndEmployee.listEmployeeSelectBox,
                isLoading: true,
            };
        case departmentAndEmployeeConstantsExport.GET_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false,
            };
        case departmentAndEmployeeConstantsExport.DELETE:
            return {
                ...state,
                listEmployeeSelectBoxEx: action.employee,
                isLoading: true,
            };

        default:
            return state;
    }
};

export default departmentAndEmployeeReducerExport;
